// styles.js
// Shared styles for VerifyEmail components

import { COLORS, LAYOUT, TYPOGRAPHY, BUTTON_STYLES, PAGE_STYLES } from '../../constants';

export const styles = {
  container: {
    ...PAGE_STYLES.container,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.background} 0%, #f8f9fa 100%)`,
    position: 'relative',
    overflow: 'hidden'
  },

  backgroundDecoration: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.05,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23CE1126' fill-opacity='1'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    pointerEvents: 'none'
  },

  card: {
    maxWidth: '600px',
    width: '90%',
    textAlign: 'center',
    border: `3px solid ${COLORS.primary}`,
    borderRadius: '20px',
    padding: '50px 40px',
    backgroundColor: COLORS.white,
    boxShadow: '0 20px 60px rgba(206, 17, 38, 0.15), 0 0 0 1px rgba(206, 17, 38, 0.05)',
    position: 'relative',
    zIndex: 1
  },

  header: {
    marginBottom: LAYOUT.spacing.xxl
  },

  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: LAYOUT.spacing.lg
  },

  logoIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, ${COLORS.primaryDark} 100%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 24px rgba(206, 17, 38, 0.3)',
    border: '4px solid white',
    overflow: 'hidden'
  },

  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },

  logoText: {
    fontSize: '32px',
    fontWeight: '900',
    color: COLORS.white,
    letterSpacing: '-1px'
  },

  successIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    color: COLORS.white,
    fontWeight: '900',
    boxShadow: '0 8px 24px rgba(34, 197, 94, 0.3)',
    border: '4px solid white'
  },

  title: {
    ...TYPOGRAPHY.heading2,
    fontSize: '2rem',
    fontWeight: '800',
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.sm
  },

  subtitle: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '1rem',
    marginTop: LAYOUT.spacing.sm
  },

  statusText: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary,
    fontSize: '1.1rem',
    marginTop: LAYOUT.spacing.lg
  },

  successText: {
    ...TYPOGRAPHY.body,
    color: '#16a34a',
    fontWeight: '700',
    fontSize: '1.3rem',
    marginTop: LAYOUT.spacing.lg,
    marginBottom: LAYOUT.spacing.md
  },

  errorText: {
    ...TYPOGRAPHY.body,
    color: COLORS.error,
    fontWeight: '700',
    fontSize: '1.2rem',
    marginTop: LAYOUT.spacing.lg
  },

  errorDetail: {
    ...TYPOGRAPHY.caption,
    color: COLORS.text.secondary,
    marginTop: LAYOUT.spacing.md,
    fontSize: '1rem',
    lineHeight: '1.6'
  },

  actionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.md,
    marginTop: LAYOUT.spacing.xl
  },

  primaryButton: {
    ...BUTTON_STYLES.primary,
    fontSize: '1.1rem',
    padding: '16px 32px',
    borderRadius: '12px',
    fontWeight: '700',
    boxShadow: '0 4px 16px rgba(206, 17, 38, 0.3)',
    transition: 'all 0.3s ease'
  },
  
  secondaryButton: {
    ...BUTTON_STYLES.secondary,
    fontSize: '1rem',
    padding: '14px 28px',
    borderRadius: '12px',
    fontWeight: '600'
  },

  helpTextContainer: {
    marginTop: LAYOUT.spacing.xxl,
    paddingTop: LAYOUT.spacing.lg,
    borderTop: '2px solid rgba(206, 17, 38, 0.1)'
  },

  helpText: {
    ...TYPOGRAPHY.caption,
    padding: LAYOUT.spacing.lg,
    backgroundColor: 'rgba(255, 193, 7, 0.08)',
    border: '2px solid rgba(255, 193, 7, 0.2)',
    borderRadius: LAYOUT.borderRadius.lg,
    color: COLORS.text.primary,
    fontSize: '0.95rem',
    lineHeight: '1.6',
    textAlign: 'left'
  }
};